import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../ts/Glob';
import * as Common from './Common';
import { Divider } from './MenuItem';
import DirsWorkspaceItem from '../DirsWorkspaceItem';
//import * as permissions from '../../../../_common/platform/ts/permissions';
//import ItemActionsSelector, { IActionButton } from './ItemActionsSelector';
//import { ActionSelector } from '../DirsTreeFlat';

function canHaveSubItems(type: Common.MenuItemTypes) {
    switch (type) {
        case Common.FAVORITES:
        case Common.RECENT:
        case Common.MY_FOLDER:
        case Common.BROWSE_ALL:
        case Common.SUBMENU:
        case Common.FOLDERWS:
        case Common.DIR_BROWSER:
            return true;

        default:
            return false;
    }
}

export function SidebarMenuItem(props: {
    value: Common.IMenuBranch;
    disableMenu?: boolean;
    hideIcons: boolean;
    glob: IGlob;

    onClick(value: Common.IMenuBranch): void;
    getItems(value: Common.IMenuBranch): any;
}) {
    const [updateKey, setUpdateKey] = React.useState({});

    React.useEffect(() => {
        const handleOnStoreChange = () => {
            setUpdateKey({});
        };

        if (props.value.type === Common.WORKSPACE) {
            props.glob.WorkspacesDirsStore.addChangeListener(handleOnStoreChange);
        }

        return () => {
            if (props.value.type === Common.WORKSPACE) {
                props.glob.WorkspacesDirsStore.removeChangeListener(handleOnStoreChange);
            }
        };
    }, []);

    const handlePanelClick = (e) => {
        if (props.onClick != null) {
            props.onClick(props.value);
        }
    };

    const { type: itemType, name: itemName } = props.value;

    let className = 'sidebar-menu-item';

    if (itemType === Common.DIVIDER) {
        return <Divider />;
    } else if (itemType === Common.WORKSPACE) {
        const wsID = props.value.refId;
        const isFavourite = props.glob.WorkspacesDirsStore.isFavorite(wsID);

        return (
            <div className={className}>
                <div className="top-menu-item workitem">
                    <DirsWorkspaceItem
                        wsid={wsID}
                        name={itemName}
                        isFavourite={isFavourite}
                        allowEditing={false}
                        hideIcons={props.hideIcons}
                        menuMode={Common.MenuModes.sideBar}
                        glob={props.glob}
                        onSelect={handlePanelClick}
                    />
                </div>
            </div>
        );
    }

    let items: any[];
    let chevron: React.JSX.Element;

    if (canHaveSubItems(itemType)) {
        if (props.value.isExpanded) {
            items = props.getItems(props.value);
        }

        // OE. panel-default class doesn't exists any more
        // className += ' panel-default'
        chevron = (
            <div className="chevron">
                {items != null ? (
                    <span className="glyphicon glyphicon-chevron-down"></span>
                ) : (
                    <span className="glyphicon glyphicon-chevron-right"></span>
                )}
            </div>
        );
    }

    //let actionSelector: React.JSX.Element;

    // if (props.disableMenu !== true) {
    //     actionSelector = (
    //         <ActionSelector
    //             item={ item }
    //             instanceID={ props.instanceId }
    //             rename={ rename }
    //             renameLoading={ renameLoading }
    //             showAddFolder={ showAddFolder }

    //             mode={ props.mode }
    //             rootID={ props.rootId }

    //             getContentLength={ props.getContentLength }

    //             onAddNewFolder={ handleAddNewFolder }
    //             onItemDelete={ getOnItemDeleteHandler(item.dirid || item.cid) }
    //             onShowActions={ props.onShowActions }
    //             onHideActions={ props.onHideActions }

    //             glob={ props.glob }
    //         />
    //     );
    // }

    const data = Common.MenuItemsData[itemType];
    const title = itemName != null ? itemName : data.title;

    let iconElement: React.JSX.Element;

    if (!props.hideIcons) {
        iconElement = <span className={data.icon}></span>;
    }

    return (
        <div className={className}>
            <div className="top-menu-item" onClick={handlePanelClick}>
                {chevron}
                <div className="menu-item-title">
                    {iconElement}
                    {title}
                </div>
                {/* { actionSelector } */}
            </div>

            <div className="sub-items">{items}</div>
        </div>
    );
}

interface IOpenedMenu extends Common.IMenuBranch {
    hideMenu: () => void;
}

let _allOpenedMenus: IOpenedMenu[] = [];

function getOpenedMenuBranch(menuID: number, result: number[]) {
    const menu = _allOpenedMenus.find((openedMenu) => openedMenu.id === menuID);

    if (menu != null) {
        result.unshift(menu.id);

        if (menu.parent != null) {
            getOpenedMenuBranch(menu.parent, result);
        }
    }
}

function hideOtherMenus(menu: Common.IMenuBranch) {
    if (_allOpenedMenus.length === 0) {
        return;
    }

    const menuID = menu.id;
    const parentMenus: number[] = [];

    if (menu.parent != null) {
        getOpenedMenuBranch(menu.parent, parentMenus);
    }

    let newOpenedMenus: IOpenedMenu[] = [];

    _allOpenedMenus.forEach((openedMenu) => {
        let hideMenu = openedMenu.id !== menuID;

        if (hideMenu) {
            hideMenu = parentMenus.indexOf(openedMenu.id) < 0;
        }

        if (hideMenu) {
            openedMenu.hideMenu();
        } else {
            newOpenedMenus.push(openedMenu);
        }
    });

    _allOpenedMenus = newOpenedMenus;
}

//let _subMenuShowingTimer: NodeJS.Timer;

export function HorizontalMenuItem(props: {
    value: Common.IMenuBranch;
    hideIcons: boolean;
    expandOnMouseOver: boolean;
    treeMode: Common.TreeModes;
    isSubItem?: boolean;
    glob: IGlob;

    onClick(value: Common.IMenuBranch): void;
    getItems(value: Common.IMenuBranch): any;
    onShowActions(): void;
    onHideActions(): void;
}) {
    const [updateKey, setUpdateKey] = React.useState({});

    const showMenu = React.useRef(false);

    const buttonRef = React.useRef<HTMLDivElement>(null);
    const menuRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        const handleOnStoreChange = () => {
            setUpdateKey({});
        };

        if (needsWorkspacesDirsStore()) {
            props.glob.WorkspacesDirsStore.addChangeListener(handleOnStoreChange);
        }

        return () => {
            //clearShowingTimer();
            showMenu.current = false;

            if (needsWorkspacesDirsStore()) {
                props.glob.WorkspacesDirsStore.removeChangeListener(handleOnStoreChange);
            }
        };
    }, []);

    React.useEffect(() => {
        const handleOnDocumentBodyClick = (e) => {
            const store = props.glob.WorkspacesNavStore.getState();

            if (store.actionsMenuIsShown) {
                return;
            }

            processHideMenu();
        };

        $(document.body).on('click', handleOnDocumentBodyClick);

        return () => {
            $(document.body).off('click', handleOnDocumentBodyClick);
        };
    });

    const needsWorkspacesDirsStore = () => {
        return props.isSubItem === true && props.value.type === Common.WORKSPACE;
    };

    const processOnClick = () => {
        //clearShowingTimer();

        if (props.onClick != null) {
            props.onClick(props.value);
        }
    };

    const getOnClickMenuHandler = (hasMenu: boolean) => {
        return (e) => {
            e.stopPropagation();
            e.preventDefault();

            hideOtherMenus(props.value);
            processOnClick();

            if (hasMenu) {
                processShowMenu();
            }
        };
    };

    const handleMenuOnMouseOver = (e) => {
        if (props.expandOnMouseOver === false || showMenu.current) {
            return;
        }

        //clearShowingTimer();
        hideOtherMenus(props.value);
        processOnClick();
        processShowMenu();
        // _subMenuShowingTimer = setTimeout(() => {
        //     _subMenuShowingTimer = null;
        // }, 250);
    };

    const processHideMenu = () => {
        if (showMenu.current) {
            showMenu.current = false;

            const currentMenuIndex = _.findIndex(_allOpenedMenus, (menu) => {
                return menu.id === props.value.id;
            });

            if (currentMenuIndex > -1) {
                //clearShowingTimer();

                _allOpenedMenus.splice(currentMenuIndex, 1);
            }

            setUpdateKey({});
        }
    };

    // const clearShowingTimer = () => {
    //     if (_subMenuShowingTimer != null) {
    //         clearInterval(_subMenuShowingTimer);
    //         _subMenuShowingTimer = null;
    //     }
    // }

    const processShowMenu = () => {
        if (showMenu.current) {
            return;
        }

        _allOpenedMenus.push({
            ...props.value,
            hideMenu: processHideMenu
        });

        showMenu.current = true;
        setUpdateKey({});
    };

    const { type: itemType, name: itemName } = props.value;
    const isSubItem = props.isSubItem === true;
    const hasMenu = canHaveSubItems(itemType);

    let className: string;
    let buttonClassName: string;

    if (isSubItem) {
        className = 'sub-item';
        buttonClassName = 'navigation-section';
    } else {
        className = 'top-menu-item';
        buttonClassName = 'btn nav-item ' + (hasMenu ? 'dropdown-toggle' : ''); //dropdown-item
    }

    if (itemType === Common.DIVIDER) {
        if (isSubItem) {
            return <Divider />;
        } else {
            return <div className="top-menu-divider" />;
        }
    } else if (isSubItem && itemType === Common.WORKSPACE) {
        const wsID = props.value.refId;
        const isFavourite = props.glob.WorkspacesDirsStore.isFavorite(wsID);

        return (
            <div className={className + ' workitem'}>
                <div className="dropdown-button btn-group">
                    <DirsWorkspaceItem
                        wsid={wsID}
                        name={itemName}
                        isFavourite={isFavourite}
                        allowEditing={false}
                        hideIcons={props.hideIcons}
                        menuMode={Common.MenuModes.horizontal}
                        glob={props.glob}
                        onSelect={processOnClick}
                        onShowActions={props.onShowActions}
                        onHideActions={props.onHideActions}
                    />
                </div>
            </div>
        );
    }

    let chevron: React.JSX.Element;
    let menu: React.JSX.Element;
    let onMenuMouseOverHandler: (e: any) => void;

    if (hasMenu) {
        let menuContent = props.getItems(props.value);

        if (isSubItem) {
            chevron = (
                <div className="chevron">
                    <span className="glyphicon glyphicon-menu-right"></span>
                </div>
            );
        } else if (menuContent == null || menuContent.length === 0) {
            //17.05.2022: Is made as a quick solution for a presentation.
            return null;
        }

        if (showMenu.current) {
            if (
                itemType === Common.BROWSE_ALL ||
                itemType === Common.FOLDERWS ||
                (props.treeMode === Common.TreeModes.flat &&
                    (itemType === Common.DIR_BROWSER || itemType === Common.MY_FOLDER))
            ) {
                menuContent = <div className="scrollable">{menuContent}</div>;
            }

            let buttonWidth = 0;

            if (isSubItem && buttonRef.current != null) {
                buttonWidth = 9 + $(buttonRef.current).width();
            }

            menu = (
                <div className="dropdown-menu" style={{ left: buttonWidth + 'px' }} ref={menuRef}>
                    {menuContent}
                </div>
            );
        }

        onMenuMouseOverHandler = handleMenuOnMouseOver;
    }

    const data = Common.MenuItemsData[itemType];
    const title = itemName != null ? itemName : data.title;

    let iconElement: React.JSX.Element;

    if (!props.hideIcons) {
        iconElement = (
            <td className="cell-icon">
                <span className={data.icon} />
            </td>
        );
    }

    return (
        <div className={className}>
            <div className={'dropdown-button btn-group' + (showMenu.current ? ' show-dropdown' : '')}>
                <div
                    className={buttonClassName}
                    ref={buttonRef}
                    onClick={getOnClickMenuHandler(hasMenu)}
                    onMouseOver={onMenuMouseOverHandler}
                >
                    <div className={'dir-node-flat-item' + (isSubItem && hasMenu ? ' folder' : '')}>
                        <table className="dir-node-flat-table">
                            <tbody>
                                <tr>
                                    {iconElement}
                                    <td className="cell-title">{title}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {chevron}
                </div>

                {menu}
            </div>
        </div>
    );
}
